import React, { memo } from "react";
import { SvgIcon } from "@mui/material";
import { IIconProps } from "@/models";
import clsx from "clsx";

const CloudSearchIcon = ({ sx, className, ...otherProps }: IIconProps) => {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={clsx("qi-icon qi-icon-device-desktop-star", className)}
      sx={{ fontSize: "inherit", fill: "none", ...sx }}
      {...otherProps}
    >
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M11 18.004H6.657C4.085 18 2 15.993 2 13.517C2 11.042 4.085 9.03501 6.657 9.03501C7.05 7.27301 8.451 5.83501 10.332 5.26201C12.212 4.69001 14.288 5.06901 15.776 6.26201C17.264 7.45201 17.938 9.26901 17.546 11.031H18.536M20.2 20.2L22 22M15 18C15 18.7957 15.3161 19.5587 15.8787 20.1213C16.4413 20.6839 17.2044 21 18 21C18.7956 21 19.5587 20.6839 20.1213 20.1213C20.6839 19.5587 21 18.7957 21 18C21 17.2044 20.6839 16.4413 20.1213 15.8787C19.5587 15.3161 18.7956 15 18 15C17.2044 15 16.4413 15.3161 15.8787 15.8787C15.3161 16.4413 15 17.2044 15 18Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export default memo(CloudSearchIcon);
